import { Screen } from '~/screens/Contact';

export const Contact = () => <Screen />;
